import { SettlementStaysFormFields, MethodOfCalcTheFee } from 'types';
import { parseStringIntoDayjsTime } from '../dateTime/parseStringIntoDayjsTime';

export const parseSettlementStaysDTOIntoSettlementStaysFormFields: (settlementStaysDTO: {
    settlementType?: string | null;
    paymentType?: string | null;
    freeHours?: number | null;
    price?: number | null;
    freeHoursAmount?: number | null;
    freeHoursTimeFrame?: string | null;
    settlementSetting?: {
        freeHoursAmount?: number | null;
        freePeriodEnd?: string | null;
        freePeriodStart?: string | null;
        stayTimeType?: string | null;
        stayFeeType?: string | null;
        timeRoundingUnitMinutes?: number | null;
        costPerHour?: number | null;
        flatMonthlyFee?: number | null;
    };
    freePeriodEnd?: string | null;
    freePeriodStart?: string | null;
    stayTimeType?: string | null;
    stayFeeType?: string | null;
    timeRoundingUnitMinutes?: number | null;
    costPerHour?: number | null;
    flatMonthlyFee?: number | null;
}) => SettlementStaysFormFields = (data) => ({
    settlementType: null, // This field is not used in the current form
    paymentType: (data.paymentType as MethodOfCalcTheFee) || null,
    freeHours: data.freeHours ? Boolean(data.freeHours) : null,
    price: data.price || null,
    freeHoursAmount: data.settlementSetting?.freeHoursAmount || data.freeHoursAmount || null,
    freeHoursTimeFrame: data.freeHoursTimeFrame ? Boolean(data.freeHoursTimeFrame) : null,
    freePeriodEnd: data.settlementSetting?.freePeriodEnd
        ? parseStringIntoDayjsTime(data.settlementSetting?.freePeriodEnd)
        : null,
    freePeriodStart: data.settlementSetting?.freePeriodStart
        ? parseStringIntoDayjsTime(data.settlementSetting?.freePeriodStart)
        : null,
    // New fields from settlementSetting or main level with defaults
    stayTimeType: (data.settlementSetting?.stayTimeType ||
        data.stayTimeType ||
        'FREE_FIRST_X_HOURS') as 'FREE_FIRST_X_HOURS' | 'FREE_PERIOD',
    stayFeeType: (data.settlementSetting?.stayFeeType || data.stayFeeType || 'ATTENDANCE_BASED') as
        | 'ATTENDANCE_BASED'
        | 'FLAT_MONTHLY',
    timeRoundingUnitMinutes: data.settlementSetting?.timeRoundingUnitMinutes || null,
    costPerHour: data.settlementSetting?.costPerHour || null,
    flatMonthlyFee: data.settlementSetting?.flatMonthlyFee || null,
});
